// shared components
import { SuperuserOnly } from '@/components/access-control';
import { DataGridToolbar } from '@/components/ui/datagrid/DataGridToolbar';

// feature-components
import {
  DegreeDayCorrectionToggle,
  ExpandCollapseButton,
  FavoritesButton,
  FullscreenButton,
  PivotViewButton,
} from '@/features/energyxplorer/portfolio/components/datagrid/PortfolioToolbarButtons';

interface PortfolioAnalysisToolbarProps {
  handleFavoritesFilterClick: (value: boolean) => void;
  isFavoritesFiltered: boolean;
  setIsFavoritesFiltered: (value: boolean) => void;
  handleExpandCollapse: () => void;
  isCollapsed: boolean;
  showDegreeDayCorrectionToggle?: boolean;
  isDegreeDayCorrectionEnabled?: boolean;
  onDegreeDayCorrectionToggle?: (value: boolean) => void;
}

const PortfolioAnalysisToolbar = ({
  handleFavoritesFilterClick,
  isFavoritesFiltered,
  setIsFavoritesFiltered,
  handleExpandCollapse,
  isCollapsed,
  showDegreeDayCorrectionToggle = false,
  isDegreeDayCorrectionEnabled = false,
  onDegreeDayCorrectionToggle,
}: PortfolioAnalysisToolbarProps) => {
  const handleFavoritesToggle = (newValue: boolean) => {
    handleFavoritesFilterClick(newValue);
    setIsFavoritesFiltered(newValue);
  };

  return (
    <DataGridToolbar
      showColumns
      showFilters
      showExport
      showExcelExport
      showQuickFilter
      showDivider
    >
      {showDegreeDayCorrectionToggle && onDegreeDayCorrectionToggle && (
        <SuperuserOnly>
          <DegreeDayCorrectionToggle
            checked={isDegreeDayCorrectionEnabled}
            onToggle={onDegreeDayCorrectionToggle}
          />
        </SuperuserOnly>
      )}
      <FullscreenButton />
      <PivotViewButton />
      <ExpandCollapseButton
        isCollapsed={isCollapsed}
        onToggle={handleExpandCollapse}
      />
      <FavoritesButton
        isFavoritesFiltered={isFavoritesFiltered}
        onToggle={handleFavoritesToggle}
      />
    </DataGridToolbar>
  );
};

export default PortfolioAnalysisToolbar;
